import { FetchJsonResult } from '../utilities/fetch';

type ProblemDetails = Extract<
    FetchJsonResult,
    { ok: false; error: 'http' }
>['problem'];

export type ApiResult<T = unknown> =
    | {
          data: T;
          type: 'success';
      }
    | {
          problem: ProblemDetails;
          type: 'problem';
      }
    | {
          type: 'error';
          name: string;
          message: string;
      };

export const apiResult = (result: FetchJsonResult): ApiResult => {
    if (result.ok) {
        return {
            type: 'success',
            data: result.data,
        };
    }

    if (result.error === 'http') {
        return {
            type: 'problem',
            problem: result.problem,
        };
    }

    return {
        type: 'error',
        name: result.name,
        message: result.message,
    };
};

export const apiQuery = async <T>(data: Promise<ApiResult<T>>) => {
    const result = await data;
    if (result.type === 'success') return result.data as T;
    if (result.type === 'problem') {
        return Promise.reject(result.problem);
    }
    throw new Error(result.message);
};

export const apiCommand = async <T>(data: Promise<ApiResult<T>>) => {
    const result = await data;
    if (result.type === 'success') return result.data as T;
    if (result.type === 'problem') {
        return Promise.reject(result.problem);
    }
    throw new Error(result.message);
};

// Typechecking utilities

export const isProblemDetails = (value: unknown): value is ProblemDetails => {
    if (!value) return false;
    if (typeof value !== 'object') return false;

    return 'type' in value && 'title' in value && 'status' in value;
};

export const apiError = (error?: unknown) => {
    return error instanceof Error
        ? error.message
        : isProblemDetails(error)
          ? error.title
          : '';
};
